/**
 * The View that shows the list of the Bill Credits
 */
import { debounce, chain, assign } from 'lodash';
import queryString from 'querystring';
import React, { Component } from 'react';
import { Button, Icon, HideText } from '@fashionnovateam/nova-ui-toolkit';
import decodeLocation from '../../Lib/Utils/Helpers/decode-location';
import { billCreditsExport } from '../../Lib/Utils/Table/table-export';
import Page from '../Page/index.ts';
import Header from '../Header/index.ts';
import BIllCreditDataGrid from './BIllCreditDataGrid.tsx';

class BillCredits extends Component {
  constructor(props) {
    super(props);

    const { getBillCredits, location } = this.props;

    this.state = {
      exporting: false,
    };

    this.handlePageChange = this.handlePageChange.bind(this);
    this.fetchBillCredits = this.fetchBillCredits.bind(this);
    this.removeSortParams = this.removeSortParams.bind(this);
    this.exportBills = this.exportBills.bind(this);
    this.fetchBillCreditsHeader = this.fetchBillCreditsHeader.bind(this);

    getBillCredits(this.currentUserId(), location.search.slice(1));
  }

  /**
   * Reads the location prop and returns the user id from the url
   */
  currentUserId() {
    const { location } = this.props;
    return location.pathname.split('/')[2];
  }

  /**
   * Adds query parameters to the url to update the query to our api and calls
   * fetchBillCredits to fetch the invoices from the database
   *
   * @param {string} name the name of the query param being added to the url
   * @param {string} value the value of the parameter being added to the url
   */
  fetchBillCredits(name, value) {
    const {
      getBillCredits,
      history,
      location: { search: params, pathname },
    } = this.props;

    const search = chain(params.slice(1))
      .thru(queryString.parse)
      .assign({ [name]: value })
      .thru((p) => (name === 'search' ? assign(p, { page: 1 }) : p))
      .pickBy()
      .thru(queryString.encode)
      .value();

    history.push({ pathname, search });

    getBillCredits(this.currentUserId(), search);
  }

  removeSortParams() {
    const {
      getBillCredits,
      history,
      location: { search: params, pathname },
    } = this.props;
    const search = chain(params.slice(1))
      .thru(queryString.parse)
      .assign({ sortBy: undefined, sortOrder: undefined })
      .pickBy()
      .thru(queryString.encode)
      .value();

    console.log(pathname, 'ici', search);
    history.push({ pathname, search });

    getBillCredits(search);
  }

  /**
   * A function that updates the url when different parameters in the component
   * are updated. Calls getBillCredits to get all bill credits that
   * match the params. Called when sort is altered using table headers
   * @param {string} sortBy the name of the parameter to be added to the url
   * @param {string} sortOrder the order parameter (ex. 'ASC'/'DESC')
   */
  fetchBillCreditsHeader(e, field) {
    const {
      getBillCredits,
      history,
      location: { search: params, pathname },
    } = this.props;

    const sortParams = decodeLocation(params);
    const { sortBy, sortOrder } = sortParams;

    let newSortOrder;
    if (!sortOrder || field !== sortBy) {
      newSortOrder = sortOrder || 'ASC';
    } else {
      newSortOrder = sortOrder === 'DESC' ? 'ASC' : 'DESC';
    }

    const search = chain(params.slice(1))
      .thru(queryString.parse)
      .assign({ sortBy: field, sortOrder: newSortOrder })
      .pickBy()
      .thru(queryString.encode)
      .value();

    history.push({ pathname, search });

    getBillCredits(this.currentUserId(), search);
  }

  /**
   * Updates the url to increment, decrement, or navigate directly to a
   * specific results page
   *
   * @param {number} page the next page to load in the table view
   */
  handlePageChange(page) {
    this.fetchBillCredits('page', page);
  }

  exportBills() {
    const userId = this.currentUserId();
    this.setState({ exporting: true });
    billCreditsExport(userId).then(() => {
      this.setState({ exporting: false });
    });
  }

  render() {
    const { count, location, billCredits, loading } = this.props;
    const params = decodeLocation(location.search);
    const { exporting } = this.state;
    const seachValue = queryString.parse(location.search.slice(1)).search || '';

    return (
      <Page.Container>
        <Header.Major
          icon="credit-card/credit-card-arrow-left"
          title="Credits"
        />
        <Header.Minor
          search={{
            value: seachValue,
            onChange: debounce(
              (value) => this.fetchBillCredits('search', value),
              500,
            ),
          }}
        >
          {exporting ? (
            <Icon.LoadingCircle />
          ) : (
            <Button size="sm" color="secondary" onClick={this.exportBills}>
              <Icon name="download/download-down" />
              <HideText notAbove="lg">Export</HideText>
            </Button>
          )}
        </Header.Minor>
        <Page.Content>
          <BIllCreditDataGrid
            rows={billCredits}
            rowCount={count}
            loading={loading}
            sortModel={
              params?.sortBy
                ? [
                    {
                      field: params.sortBy,
                      sort: params.sortOrder === 'ASC' ? 'asc' : 'desc',
                    },
                  ]
                : []
            }
            onSortModelChange={(model) => {
              const sortItem = model[0];
              if (sortItem) {
                this.fetchBillCreditsHeader(undefined, sortItem.field);
              } else {
                this.fetchBillCreditsHeader(undefined, params.sortBy);
              }
            }}
            pageSizeOptions={[15]}
            paginationModel={{
              pageSize: 15,
              page: params?.page ? params.page - 1 : 0,
            }}
            onPaginationModelChange={(model) => {
              this.handlePageChange(model.page + 1);
            }}
          />
        </Page.Content>
      </Page.Container>
    );
  }
}

export default BillCredits;
